var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.976074,
    width: 37.024,
    height: 37.024,
    rx: 10.68,
    fill: "#916145"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8389 15.244V24.272H13.4276V15.244H15.8389ZM13.2774 12.8911C13.2774 12.5407 13.3998 12.2514 13.6445 12.0233C13.8893 11.7953 14.2175 11.6813 14.6291 11.6813C15.0351 11.6813 15.3605 11.7953 15.6053 12.0233C15.8556 12.2514 15.9808 12.5407 15.9808 12.8911C15.9808 13.2415 15.8556 13.5308 15.6053 13.7588C15.3605 13.9869 15.0351 14.1009 14.6291 14.1009C14.2175 14.1009 13.8893 13.9869 13.6445 13.7588C13.3998 13.5308 13.2774 13.2415 13.2774 12.8911ZM20.5194 17.1714V24.272H18.1164V15.244H20.3692L20.5194 17.1714ZM20.169 19.4409H19.5182C19.5182 18.7734 19.6044 18.1727 19.7768 17.6387C19.9493 17.0991 20.1912 16.6402 20.5027 16.262C20.8142 15.8782 21.1841 15.5861 21.6125 15.3859C22.0463 15.1801 22.5303 15.0772 23.0643 15.0772C23.487 15.0772 23.8736 15.1383 24.2241 15.2607C24.5745 15.3831 24.8749 15.5778 25.1252 15.8448C25.3811 16.1118 25.5757 16.465 25.7092 16.9044C25.8483 17.3439 25.9178 17.8807 25.9178 18.5148V24.272H23.4981V18.5064C23.4981 18.1059 23.4425 17.7944 23.3313 17.5719C23.22 17.3494 23.0559 17.1937 22.839 17.1047C22.6276 17.0101 22.3662 16.9628 22.0547 16.9628C21.7321 16.9628 21.4511 17.0268 21.212 17.1548C20.9783 17.2827 20.7836 17.4607 20.6279 17.6888C20.4777 17.9113 20.3637 18.1727 20.2858 18.4731C20.2079 18.7734 20.169 19.0961 20.169 19.4409Z",
    fill: "#F2F7F7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.06390d37eada4bd37519b39f29f45118.svg";
export { ForwardRef as ReactComponent };